import { enableStaticRendering } from 'mobx-react'
import mainStore from './main'

const isServer = typeof window === 'undefined'
enableStaticRendering(isServer)

export class Store {
  constructor(initialState: any = {}) {
    for (const k in mainStore) {
      if (mainStore.hasOwnProperty(k)) {
        this[k] = new mainStore[k](initialState[k])
      }
    }
  }
}

let store: any = null
export function initStore(initialState = {}) {
  if (isServer) {
    return new Store(initialState)
  }
  if (store === null) {
    store = new Store(initialState)
  }
  return store
}
